<div class="mc-tooltip-panel" [ngClass]="tooltipPanelClass">
  <ng-content></ng-content>
  <div class="mc-tooltip-panel__triangle">
    @if (!hideTriangle) {
      <div class="mc-tooltip-panel__triangle-inner"></div>
    }
  </div>
</div>
